import { publicRequest, userRequest } from "../../../requestMeth";
import { createWidgetStart, createWidgetFailure, createWidgetSuccess, widgetStart, widgetSuccess, widgetFailure,
  deleteFailure, deleteStart, deleteSuccess
} from "../../reducers/widgetRedux"; 


export const createWidget = async (dispatch, data, token) => {
    dispatch(createWidgetStart());
    try {
        const res = await publicRequest.post("/widget", data,{
            headers: { token: `Bearer ${token}` }
        });
        dispatch(createWidgetSuccess(res.data));
        return res.data;
    } catch (error) {
        dispatch(createWidgetFailure());
        throw error;
    }
};

export const getAllWidgets = async (dispatch, token) => {
    dispatch(widgetStart());
    try {
      const res = await publicRequest.get("/widget", {
        headers: { token: `Bearer ${token}` }
      });
      dispatch(widgetSuccess(res.data));
      return res.data;
    } catch (error) {
      dispatch(widgetFailure());
    }
  };

  export const deleteWidget = async (dispatch, id, token) =>{
    dispatch(deleteStart());
    try {
      const res = await userRequest.delete(`/widget/${id}`, {
        headers: { token: `Bearer ${token}` }
    });
        dispatch(deleteSuccess(res.data));
    } catch (error) {
        dispatch(deleteFailure());
    }
  };

  export const deleteBoard = async (dispatch, boardName, token) => {
    try {
      const res = await userRequest.delete(`/widget/board/${boardName}`, {
        headers: { token: `Bearer ${token}` }
      });
      return res.data;
    } catch (error) {
      console.error("Error deleting board:", error);
      return false;
    }
  };

  export const updateBoardName = async (dispatch, board, name, token) => {
    try {
      await userRequest.patch(
        "/widget/board-name",
        { board, name },
        {
          headers: { token: `Bearer ${token}` },
        }
      );
      return true;
    } catch (error) {
      return false;
    }
  };

  export const updateWidget = async (dispatch, id_widget, data, token) => {
    try {
      const res = await userRequest.patch(`/widget/${id_widget}`, data, {
        headers: { token: `Bearer ${token}` }
      });
      return res.data;
    } catch (error) {
      return false;
    }
  };